module.exports = __webpack_public_path__ + "img/empty-image.2f705f83.png";